// MARK:- <as-unmute-video> swaps a muted autoplay video to native controls on first interaction
class AsUnmuteVideo extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = async (event) => {
    const button = event.target.closest('.video-unmute-button');
    if (!button) return;

    const video = this.querySelector('video');
    if (!video) return;

    event.preventDefault();

    video.muted = false;
    video.currentTime = 0;
    video.removeAttribute('loop');
    video.setAttribute('controls', '');

    try {
      await video.play();
      button.hidden = true;
    } catch {
      // Browser blocked unmuted playback (e.g. iOS low-power mode). Revert so the user can retry.
      video.muted = true;
      video.removeAttribute('controls');
      video.setAttribute('loop', '');
      video.play().catch(() => {});
    }
  };
}

customElements.define('as-unmute-video', AsUnmuteVideo);
